import { http } from 'msw';
import vars from '@/config/vars';
import { localesHeHandler } from './locales.handler';
import { loanOptionsHandler } from './loanOptions.handler';
import { saveHandler } from './save.handler';
import { calculateHandler } from './calculate.handler';
import { disposalboardHandler } from './disposalboard.handler';
import { userStatusHandler } from './userStatus.handler';
import { userLoginHandler } from './userLogin.handler';
import { gellAllOffersHandler } from './getAllOffers.handler';
import { calculateCycleMortgageWithSamePeriodHandler } from './calculateCycleMortgageWithSamePeriod.handler';

const { baseUrl } = vars.request;
const handlers = [];

const localesHandlers = [
  http.get(`${baseUrl}/v1/locales/he.json`, localesHeHandler),
];

const restHandlers = [
  http.post(`${baseUrl}/v1/user/userLogin`, userLoginHandler),
  http.post(`${baseUrl}/v1/user/getStatus`, userStatusHandler),
  http.post(`${baseUrl}/v1/user/getStatus`, userStatusHandler),
  http.post(`${baseUrl}/v1/loan/getByBorrowerAge`, loanOptionsHandler),
  http.post(`${baseUrl}/v1/offer/createOrUpdate`, saveHandler),
  http.post(`${baseUrl}/v1/offer/getAll`, gellAllOffersHandler),
  http.post(`${baseUrl}/v1/mortgage/calculateCycleMortgageWithSamePeriod`, calculateCycleMortgageWithSamePeriodHandler),
  http.post(`${baseUrl}/v1/calculation/calculateOfferForMaxPeriodWithoutBankMixDetailsByDetails`, calculateHandler),
  http.post(`${baseUrl}/v1/calculation/calculateOfferForKnownPeriodAndRiskByDetails`, disposalboardHandler),
  http.post(`${baseUrl}/v1/offer/calculateForMaxPeriodWithoutBankMixDetailsByDetails`, calculateHandler),
  http.post(`${baseUrl}/v1/offer/calculateOfferForKnownPeriodAndRiskByDetails`, disposalboardHandler),
];

if (vars.mocks.locales) {
  handlers.push(...localesHandlers);
}

if (vars.mocks.rest) {
  handlers.push(...restHandlers);
}

export default handlers;
